const Dashboard = () => {

  return (
    <div className="hk-pg-wrapper">
      <div className="hk-pg-body py-0">
        <div className="page-wrap">
          <div className="page-content ps-0">
            <div className="page-detail-wrap">
              <div className="page-body">
                <div data-simplebar className="nicescroll-bar">
                  <div className="container-fluid">
                    <div className="row g-3">
                      <div className="col-lg-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between"><div>
                              <p className="mb-1 text-muted">Total Clients & Users</p>
                              <h6 className="h2">0</h6>
                            </div>
                              <div className="flex-shrink-0">
                                <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                  <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-2 mt-1">
                              <span className="badge badge-sr bg-green-light-5 text-success mb-0">
                                <i className="ri-arrow-up-line align-middle"></i>0 % </span>
                            <span className="fs-13 text-muted">vs. previous month</span>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div className="col-lg-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between"><div>
                              <p className="mb-1 text-muted">Total Clients & Users</p>
                              <h6 className="h2">0</h6>
                            </div>
                              <div className="flex-shrink-0">
                                <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                  <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-2 mt-1">
                              <span className="badge badge-sr bg-green-light-5 text-success mb-0">
                                <i className="ri-arrow-up-line align-middle"></i>0 % </span>
                            <span className="fs-13 text-muted">vs. previous month</span>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div className="col-lg-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between"><div>
                              <p className="mb-1 text-muted">Total Clients & Users</p>
                              <h6 className="h2">0</h6>
                            </div>
                              <div className="flex-shrink-0">
                                <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                  <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-2 mt-1">
                              <span className="badge badge-sr bg-green-light-5 text-success mb-0">
                                <i className="ri-arrow-up-line align-middle"></i>0 % </span>
                            <span className="fs-13 text-muted">vs. previous month</span>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div className="col-lg-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between">
                              <div>
                              <p className="mb-1 text-muted">Total Clients & Users</p>
                              <h6 className="h2">0</h6>
                            </div>
                              <div className="flex-shrink-0">
                                <div className="avatar avatar-sm avatar-icon avatar-soft-success avatar-smmm">
                                  <span className="initial-wrap"><i className="ri-store-3-fill"></i></span>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-2 mt-1">
                              <span className="badge badge-sr bg-green-light-5 text-success mb-0">
                                <i className="ri-arrow-up-line align-middle"></i>0 % </span>
                            <span className="fs-13 text-muted">vs. previous month</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Dashboard